/** The credits' words (docs/spec/04 §6), and the one line that names the 1981 game. Pure. */

import { ENEMY_NAMES, SHIP_NAME, TRIBUTE } from '../../app/brand';
import { printable, wrap } from '../kit/text';
import { TEXT_COLS } from '../kit/theme';

/** How many of the credit lines are the cast (drawn brighter). */
export const CAST_LINES = 2;

/** Who is in it, and how it was made: five lines, the third blank. */
export function creditLines(): string[] {
  // The names are the owner's to change (brand.ts): a longer one is cut rather than run off the screen.
  const cast = [`STARRING THE ${SHIP_NAME}`, `THE ${ENEMY_NAMES.empress} AND HER HIVE`];
  return [
    ...cast.map((line) => wrap(line, TEXT_COLS)[0] ?? ''),
    '',
    'EVERY SPRITE, SOUND AND',
    'NOTE IS MADE FROM CODE.',
  ];
}

/** The tribute line (`src/app/brand.ts`), wrapped to the 26 columns in the font's own letters. */
export function tributeLines(): string[] {
  return wrap(printable(TRIBUTE), TEXT_COLS);
}

/** How long the chase takes to cross the screen and come round again, ms. */
export const CHASE_MS = 7000;

/** The x of the chase's leader at `ms` on a screen `width` wide: off the left edge to off the right. */
export function chaseX(ms: number, width: number): number {
  const span = width + 160;
  return Math.round((((ms % CHASE_MS) + CHASE_MS) % CHASE_MS) / CHASE_MS * span) - 24;
}
